import { render, staticRenderFns } from "./GoodList.vue?vue&type=template&id=c309554c&scoped=true"
import script from "./GoodList.vue?vue&type=script&lang=js"
export * from "./GoodList.vue?vue&type=script&lang=js"
import style0 from "./GoodList.vue?vue&type=style&index=0&id=c309554c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c309554c",
  null
  
)

export default component.exports